import React from 'react';
import { Button, Progress } from 'antd';
import { notEqual } from 'ramda-adjunct';
import { equals, prop } from 'ramda';
import colors from '../colors';
import BaseModal from './BaseModal';

const ModalLoading = ({ visible, onClick, progress, infoLoading, textProgression, elapsedTime }) => {
  return (
    <BaseModal
      className="modal-loading"
      visible={visible}
      footer={[
        <Button
          key="ok"
          type="primary"
          disabled={notEqual(100, progress)}
          onClick={onClick}
        >
          Terminer
        </Button>
      ]}
      width="25%"
    >
      {infoLoading}
      <div className="flex w-full justify-between">
        <Progress
          percent={progress}
          status={equals(100, progress) ? 'normal' : 'active'}
          showInfo={false}
          strokeColor={{ from: prop('flexi-select-active', colors), to: prop('flexi-primary-color', colors) }}
        />
        <p className="ml-4 w-24 text-right">{textProgression}</p>
      </div>
      { elapsedTime && (
        <div>{`Temps écoulé : ${elapsedTime}s`}</div>
      )}
    </BaseModal>
  );
};

export default ModalLoading;
